import { useCallback } from 'react';
import { usePost, UsePostParams } from '../../../../../../api';

export interface TestMFATokenPayloadData {
    username: string;
    domainName: string;
    authenticator?: string;
    provider_ids?: string[];
    tokenId?: string;
    tokenType?: string | null;
    device?: string | null;
}

export interface TestMFAResponseData {
    sentSuccessfully: boolean;
    responseText: string;
    wallID: string;
    requestID: string;
}

export type UseTestMFAParams = UsePostParams<TestMFATokenPayloadData, TestMFAResponseData>;

export const useTestMFAToken = (params: UseTestMFAParams) => {
    const { post, loading, error } = usePost<Partial<TestMFATokenPayloadData>, TestMFAResponseData>(params);

    const testMFATokenMutation = useCallback(
        (payload: Partial<TestMFATokenPayloadData>) => post(`/Settings/testMFAToken`, payload),
        [post]
    );

    return {
        loading,
        error,
        testMFATokenMutation
    };
};
export default useTestMFAToken;
